//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/AME.js";
import "../no/Builder.js";
let d=[[],[[[],"ClearProductPropertyRules",{},0,0],[["propertyName","assignAction","removeAction"],"AddProductPropertyRules",{},3,0],[[],"ResetToDefault",{},0,0]],[]];
SPLM.AME.ProductPropertyRulesBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.AME.ProductPropertyRulesBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.AME.ProductPropertyRulesBuilder.PropertyMergeOption = Object.freeze({
    "Invalid" : "Invalid", "Yes" : "Yes", "No" : "No", "OnlyIfEmpty" : "OnlyIfEmpty"});

export default SPLM;